// Self-hosted fonts (no request to Google at runtime). Only the weights we use.
import '@fontsource/abril-fatface/400.css';
import '@fontsource/josefin-sans/400.css';
import '@fontsource/josefin-sans/600.css';
import '@fontsource/josefin-sans/700.css';
import '@fontsource/special-elite/400.css';

/** Waits (with a timeout) for the three families to be ready so the splash can report it. */
export async function waitForFonts(timeoutMs = 3000): Promise<boolean> {
  if (!('fonts' in document)) return true;
  const load = Promise.all([
    document.fonts.load("1rem 'Abril Fatface'"),
    document.fonts.load("600 1rem 'Josefin Sans'"),
    document.fonts.load("1rem 'Special Elite'"),
  ]).then(() => true);
  const timeout = new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(false);
    }, timeoutMs);
  });
  return Promise.race([load, timeout]);
}
